import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
      const sid = params.get("session_id");
      if (!sid) {
        nav("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        if (data?.user) {
          setUser(data.user);
        }
        // Clean fragment from URL and go home
        window.history.replaceState({}, "", "/home");
        nav("/home", { replace: true });
      } catch (e) {
        setError(formatApiError(e));
        setTimeout(() => nav("/login", { replace: true }), 2000);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1A2A6C] to-[#26B5A8]" data-testid="auth-callback">
      <div className="brut-card px-8 py-6 text-center max-w-sm mx-4">
        <p className="font-heading text-xl font-black text-[#1A1D29] mb-1">Accesso con Google</p>
        <p className="text-sm text-[#8A91A8]">{error || "Stiamo completando il tuo accesso…"}</p>
      </div>
    </div>
  );
}
